/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Plan_HobbyInputs */

const en_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hobby plan`)
};

const zh_hans1_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hobby 套餐`)
};

const pt_br2_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plano Hobby`)
};

const es_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plan Hobby`)
};

const fr_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forfait Hobby`)
};

const de_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hobby-Tarif`)
};

const ru_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`тариф Hobby`)
};

const it_scrape_router_plan_hobby = /** @type {(inputs: Scrape_Router_Plan_HobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`piano Hobby`)
};

/**
* | output |
* | --- |
* | "Hobby plan" |
*
* @param {Scrape_Router_Plan_HobbyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_plan_hobby = /** @type {((inputs?: Scrape_Router_Plan_HobbyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Plan_HobbyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_plan_hobby(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_plan_hobby(inputs)
	if (locale === "es") return es_scrape_router_plan_hobby(inputs)
	if (locale === "fr") return fr_scrape_router_plan_hobby(inputs)
	if (locale === "de") return de_scrape_router_plan_hobby(inputs)
	if (locale === "ru") return ru_scrape_router_plan_hobby(inputs)
	if (locale === "it") return it_scrape_router_plan_hobby(inputs)
	return en_scrape_router_plan_hobby(inputs)
});